<ws-modal-wrapper headerLabel="Budget Site/Parcel Characteristics"
                  [hideSave]="!canEdit"
                  (cancel)="cancel()"
                  (save)="save()"
                  [cancelLabel]="canEdit ? 'Cancel' : 'Close'"
                  [loading]="!inUseDescriptors"
                  [suppressKeyboardEvents]="true">
    @if (!budgetDescriptors.length && !inUseDescriptors.site && !inUseDescriptors.parcel) {
        <div class="text-center">
            <em>Company does not have any characteristics in use.</em>
        </div>
    }
    @if (budgetDescriptors.length) {
        <div style="max-height: 400px; overflow: auto;">
            <table class="table table-striped table-condensed">
                <tr>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Entity</th>
                    @if (canEdit) {
                        <th></th>
                    }
                </tr>
                @for (item of budgetDescriptors; track item) {
                    <tr>
                        <td>{{ item.descriptorName }}</td>
                        <td>{{ item.categoryName }}</td>
                        <td>
                            @if (item.entityTypeId === EntityTypeIds.SITE) {
                                <span>Site</span>
                            }
                            @if (item.entityTypeId === EntityTypeIds.PARCEL) {
                                <span>Parcel</span>
                            }
                        </td>
                        @if (canEdit) {
                            <td style="width: 1px;">
                                <div>
                                    <button class="ace-btn has-icon btn-text btn-primary btn-danger m-0"
                                            (click)="removeDescriptor(item)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        }
                    </tr>
                }
            </table>
        </div>
    }
    @if (!budgetDescriptors.length) {
        <div class="text-center">
            <em>List Empty</em>
        </div>
    }
    @if (canEdit) {
        <div class="company-in-use-characteristics">
            <label>Add Characteristic:</label>
            <div class="mb-4">
                <budget-descriptor-selector
                    placeholder="Site"
                    [inUseDescriptors]="inUseDescriptors.site"
                    [disabled]="!inUseDescriptors.site"
                    (onDescriptorSelected)="descriptorSelected($event)">
                </budget-descriptor-selector>
            </div>
            <div class="mb-4">
                <budget-descriptor-selector
                    placeholder="Parcel"
                    [inUseDescriptors]="inUseDescriptors.parcel"
                    [disabled]="!inUseDescriptors.parcel"
                    (onDescriptorSelected)="descriptorSelected($event)">
                </budget-descriptor-selector>
            </div>
        </div>
    }
</ws-modal-wrapper>
